'use client';

import { c as _c } from "react/compiler-runtime";
import { StarRatingTooltipContent } from './Content';
import { useTooltipPageAction } from './hooks';
import type { StarRatingTooltipProps } from './types';
export const MonetizableStarRatingTooltip = t0 => {
  const $ = _c(4);
  const {
    segmentActionSection,
    popupCss
  } = t0;
  const handleTooltipClickPageAction = useTooltipPageAction();
  let t1;
  if ($[0] !== handleTooltipClickPageAction || $[1] !== popupCss || $[2] !== segmentActionSection) {
    t1 = <StarRatingTooltipContent segmentActionSection={segmentActionSection} popupCss={popupCss} handleTooltipClickPageAction={handleTooltipClickPageAction} />;
    $[0] = handleTooltipClickPageAction;
    $[1] = popupCss;
    $[2] = segmentActionSection;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};